// extracted by mini-css-extract-plugin
module.exports = {"root":"QICWZr","secondary":"OiW64d","tax":"AR4yaC"};